var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_942_3503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8146 19.1824C18.8146 19.6268 18.458 19.9872 18.0181 19.9872C17.5781 19.9872 17.2216 19.6268 17.2216 19.1824L17.2146 19.1073C17.2146 19.0755 17.2203 19.0449 17.2235 19.0137C16.7262 15.4812 13.7286 12.8854 10.0784 12.8447C10.0491 12.8453 10.0211 12.8491 9.99179 12.8491C9.9625 12.8491 9.93446 12.8453 9.90583 12.8447C6.29762 12.8854 3.32867 15.4233 2.78111 18.8946C2.79895 18.9628 2.8123 19.0334 2.8123 19.1073L2.81995 19.183C2.81995 19.6344 2.45766 20.0006 2.0107 20.0006C1.56436 20.0006 1.20146 19.6345 1.20146 19.183L1.20083 19.1754H1.18555C1.18745 19.1518 1.19255 19.1289 1.19508 19.1053C1.19508 19.0379 1.20527 18.9742 1.22055 18.9111C1.63502 15.6551 3.79535 13.0216 6.73501 11.8877C5.02354 10.7798 3.90742 8.82195 3.90742 6.5852C3.90742 3.12597 6.56821 0.321289 9.99241 0.321289C13.416 0.321289 16.0768 3.12597 16.0768 6.5852C16.0768 8.8213 14.9619 10.7785 13.2511 11.8864C16.1703 13.0115 18.3205 15.6143 18.7586 18.838C18.7885 18.9226 18.8082 19.0124 18.8082 19.1073L18.8146 19.1824ZM14.6779 6.58711C14.6779 3.97154 12.5793 1.85131 9.99049 1.85131C7.40165 1.85131 5.30307 3.97217 5.30307 6.58711C5.30307 9.20271 7.40165 11.3229 9.99049 11.3229C12.5787 11.3229 14.6779 9.20271 14.6779 6.58711Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_942_3503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccount);
export default __webpack_public_path__ + "static/media/ic_account.f5da9105dca7a816e02142df9242d3ac.svg";
export { ForwardRef as ReactComponent };